import {
  Input,
  Component,
  ElementRef,
  OnDestroy,
  EventEmitter,
  Output,
  ContentChildren,
  QueryList,
  AfterContentInit,
  TemplateRef,
} from '@angular/core';
import {
  HotkeyService,
  DialogBase,
  SortExpression,
  Destroy,
  SearchExpression,
  SearchConfig,
  tr,
  DialogService,
  DialogRef,
  IQueryResult,
  ISortEvent,
  TemplateDirective,
  getTemplateByName,
  Key,
} from '@kpd/framework-ngx';
import { FormGroup, FormControl } from '@angular/forms';

@Component({
  selector: 'app-link-entities',
  templateUrl: './link-entities.component.html',
})
export class LinkEntitiesComponent extends DialogBase implements AfterContentInit, OnDestroy {
  @Input()
  header: string;
  @Input()
  searchConfig: SearchConfig;
  @Input()
  cols: any[];
  selectedKeys: Key<string>[] = [];
  keysToExclude: Key<string>[] = [];
  sortExpression: SortExpression = new SortExpression();
  searchForm: FormGroup;
  @Destroy()
  destroy$: any;
  totalCount = 0;
  items = new Array<any>();
  itemsFiltered: any[] = [];
  index: number;
  loading = false;
  @Input()
  error: string | null;
  searchExpression: SearchExpression;
  @Output()
  selectionChanged = new EventEmitter<Key<string>[]>();
  @ContentChildren(TemplateDirective)
  templates: QueryList<TemplateDirective>;
  tableExtraTemplate: TemplateRef<any>;

  constructor(dialogService: DialogService, element: ElementRef, hotKeyService: HotkeyService) {
    super('linkEntities', dialogService, element, hotKeyService);
  }

  ngAfterContentInit(): void {
    this.tableExtraTemplate = getTemplateByName(this.templates, 'tableExtra');
  }

  onBeforeShow(dialogRef: DialogRef): void {
    const data: { queryResult: IQueryResult; keysToExclude: Key<string>[] } = dialogRef.data;
    this.totalCount = data.queryResult.totalCount - (data.keysToExclude ? data.keysToExclude.length : 0);
    this.items = this.itemsFiltered = data.queryResult.result.filter(
      item => !data.keysToExclude.map(key => key.toString()).includes(item.key.toString()),
    );
    this.selectedKeys = [];
    this.loading = false;
    this.searchExpression = new SearchExpression();
    this.sortExpression = new SortExpression();
    this.searchForm = new FormGroup({
      search: new FormControl(),
    });

    this.keysToExclude = data.keysToExclude;
    super.onBeforeShow(dialogRef);
  }

  onSelectionChanged(event: { index: number; selection: Key<string>[] }): void {
    this.selectedKeys = event.selection;
    this.selectionChanged.emit(this.selectedKeys);
  }

  onAdd(): void {
    this.loading = true;
    this.close(this.selectedKeys);
  }

  onSort(event: ISortEvent): void {
    this.sortExpression = event.sortExpression;
  }

  onSearch(searchExpression: SearchExpression): void {
    this.searchExpression = searchExpression;
    this.itemsFiltered = this.items.filter(item => {
      return searchExpression.checkItem(item);
    });
  }

  createTotalCountLabel(count: number): string {
    return (count || 0) + ' ' + tr('Results');
  }
}
